/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export enum ProjectConfigurationKeyEnum {
  ENVIRONMENT_CLASSIFICATION_PATTERNS = 'ENVIRONMENT_CLASSIFICATION_PATTERNS'
}
